export const FlightConstants = {
  FLIGHT: 'flight',
  LINE_ITEM_LEVEL_FLIGHT: 'line_item_level_flight',
  FLIGHTS: 'Flights',
  ID: 'id',
  NAME: 'name',
  DISPLAY_NAME: 'display_name',
  SELECT_PLACEHOLDER: 'Select',
  CLIENT: 'Client',
  ORDER_CLIENT_ID: 'order_client_id',
  ORDER: 'Order',
  ORDER_ID: 'order_id',
  LINE_ITEM_ID: 'line_item_id',
  PRODUCT: 'Product',
  FORM_ID: 'form_id',
  PARENT_FORM_ID: 'parent_form_id',
  STATUS_TITLE: 'Flight Status',
  STATUS_FIELD: 'status',
  START_DATE_TITLE: 'Start Date',
  START_DATE_FIELD: 'start_date',
  END_DATE_TITLE: 'End Date',
  END_DATE_FIELD: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  CREATED_BY: 'Created By',
  CREATED_BY_USER_ID: 'created_by_user_id',
  TOTAL_BUDGET_TITLE: 'Total Budget',
  FIELDS: 'fields',
  CLIENT_IDS: 'client_ids',
  FILES: 'Files',
  LINK: ' link',
  ACTIONS: 'actions',
  RIGHT: 'right',
  DD_MM_YYYY: 'DD/MM/YYYY',
  MM_DD_YYYY: 'MM/DD/YYYY',
  COPY: 'Copy',
  CREATED_AT_SORT: '-created_at',
  STATUS_ID: 'status_id',
  DUE_DATE: 'due_date',
  YYYY_MM_DD: 'YYYY-MM-DD',
  COMMENTS: 'comments',
  AUTO_CREATED: 'auto_created',
  __OVERRIDDEN: '__OVERRIDDEN',
  __OVERRIDE: '__OVERRIDE',
  GENERIC: 'Generic',
  MANUAL: 'Manual',
  OPEN: 'open',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
  NUMBER: 'number',
  STRING: 'string',
  OBJECT: 'object',
};

export const FlightEvent = {
  APPLY_FILTERS: 'apply-filters',
  CLEAR_FILTERS: 'clear-filters',
  INPUT: 'input',
  UPDATE_FLIGHT_STATUS: 'update-flight-status',
  UPDATE_FLIGHT_LIST: 'update-flights-list',
  MOUSE_MOVE: 'mousemove',
  MOUSE_UP: 'mouseup',
  CHANGE_DATA: 'change-data',
  EXPAND_TASK: 'expand-task',
  UPDATE_TASK_LIST: 'update-list',
  CHANGE_STATUS: 'change-status',
  UPDATE_LINE_ITEM: 'update-line-item',
  UPDATE_LINE_ITEMS_LIST: 'update-line-items-list',
  REGENERATE_FLIGHTS: 'regenerate-flights',
  ADD_NEW_FLIGHT: 'add-new-flight',
  UPDATE_FLIGHT_DETAILS: 'update-flight-details',
  DUPLICATE_FLIGHT: 'duplicate-flight',
  DELETE_FLIGHT: 'delete-flight',
  CONFIG_CHANGES: 'config-changes',
  MODAL_CLOSED_WITHOUT_FLIGHTS: 'modal-closed-without-flights',
};

export const FlightRoutePaths = {
  SAVE_PREFERENCES_ROUTE: '/savecolumnpreferences',
  EDIT_FLIGHT_ROUTE_PATH_NAME: 'edit-entity-flight',
};

export const FlightDetailsTabConstants = {
  OVERVIEW: 'overview',
  TASKS: 'tasks',
  FILES: 'files',
};

export const AutoCreateFlightOptions = {
  CHOOSE: 'choose',
  CUSTOM: 'custom',
  DEFINED: 'defined',
  NONE: 'none',
  MONTHLY_PREFIX: 'monthly_',
  WEEKLY_PREFIX: 'weekly_',
};

export const FlightsRoutePathName = 'flights';

export const FlightReferences = {
  FLIGHT_CREATION_MODAL: 'flight-creation-modal',
};

export const ErrorMessageType = 'is-danger is-light';

export const DEFAULT_FLIGHT_LIST_SORT_QUERY = '-created_at,-id';
